// @flow
import type { SelectNativeOption } from 'reshaped';

import { Option } from './Option';

type LegacyOption = {
  value: string,
  text: string,
};

export type OptionsProps = Array<SelectNativeOption | LegacyOption>;

type Props = {
  label: string,
  options: OptionsProps,
};

const normalizeOption = (
  option: SelectNativeOption | LegacyOption,
): SelectNativeOption => {
  if ('label' in option) {
    return option;
  }

  // Convert `react-select` props to Reshaped Select props
  return {
    value: option.value,
    label: option.text,
    disabled: 'disabled' in option ? option.disabled : undefined,
  };
};

export function OptionGroup({ label, options }: Props): React.MixedElement {
  return (
    // eslint-disable-next-line @gandi/gandi/no-global-element
    <optgroup label={label}>
      {options.map(option => {
        const normalized = normalizeOption(option);
        return <Option key={normalized.value} {...normalized} />;
      })}
    </optgroup>
  );
}
